module.exports = __webpack_public_path__ + "assets/img/elektrines-efektyvumas.ce6c022a.webp";